import Vue from "vue"
import { PermissionsService } from "@/plugins/permissions"
import store from "@/store"
import { tracker } from "@openreplay/tracker"
export default {
    namespaced: true,

    state() {
        return {
            permissions: null,
            isLoaded: false,
        }
    },
    mutations: {
        setPermissions(state, data) {
            state.permissions = data
            state.isLoaded = true
        },
    },
    actions: {
        async fetch({ dispatch }, data) {
            return await Vue.auth.fetch(data).catch((error) => {
                if (error.response.status === 401) {
                    dispatch("auth/logout")
                }
            })
        },
        setPermissions({ commit }, data) {
            commit("setPermissions", data)
        },
        refresh(ctx, data) {
            return Vue.auth.refresh(data)
        },
        checkIfUserSetUp(ctx) {
            let permissionsService = new PermissionsService(store)

            if (permissionsService.hasAggregatorRole() || permissionsService.hasSuperAdminRole()) {
                return true
            }

            return (
                permissionsService.hasBasicUserRole() && permissionsService.canAccessAnyLocation()
            )
        },
        login(ctx, data) {
            data = data || {}

            Vue.auth.logout()
            ctx.dispatch("sidebar/setCompany", null, { root: true })
            ctx.commit("twoFactorAuth/setStatus", null, { root: true })

            return new Promise((resolve, reject) => {
                Vue.auth
                    .login({
                        ...(data.url && { url: data.url }),
                        data: data.body,
                        remember: data.remember,
                        staySignedIn: data.staySignedIn,
                        redirect: null,
                    })
                    .then((res) => {
                        const permissions = res.data.data.user.permissions || []
                        ctx.commit("setPermissions", permissions)

                        const user = res.data.data.user
                        if (!user.isDemoUser) {
                            localStorage.removeItem("customTheme")
                            localStorage.removeItem("customLogo")
                        }

                        if (data.remember) {
                            Vue.auth.remember(
                                JSON.stringify({
                                    name: ctx.getters.user.first_name,
                                }),
                            )
                        }

                        const forceStart = process.env.VUE_APP_OPENREPLAY_FORCE_START === "true"
                        const hasAnalyticsConsent =
                            Vue.prototype.$cookieConsent?.hasConsentTo("analyticsCookies")

                        if (user?.email && (forceStart || hasAnalyticsConsent)) {
                            tracker.stop()
                            tracker.start({ userID: user.email })
                        }

                        resolve(res)
                    }, reject)
            })
        },

        register(ctx, data) {
            data = data || {}

            return Vue.auth.register({
                url: "auth/register",
                data: data.body,
                autoLogin: false,
            })
        },

        impersonate(ctx, data) {
            Vue.auth
                .impersonate({
                    url: "auth/impersonate",
                    data: {
                        data: {
                            userId: data.user.id,
                        },
                    },
                    redirect: "/",
                })
                .then(() => {
                    ctx.dispatch("sidebar/setCompany", null, { root: true })
                    ctx.dispatch("sidebar/fetchMenu", null, { root: true })

                    window.location.reload()
                })
        },

        unimpersonate(ctx) {
            Vue.auth
                .unimpersonate({
                    redirect: "/",
                })
                .then(() => {
                    ctx.dispatch("sidebar/setCompany", null, { root: true })
                    ctx.dispatch("sidebar/fetchMenu", null, { root: true })

                    window.location.reload()
                })
        },

        logout(ctx) {
            const user = Vue.auth.user()
            const isDemoUser = user?.isDemoUser

            ctx.dispatch("auth/unimpersonate", null, { root: true })
            ctx.commit("setupGrid/resetState", null, { root: true })

            if (isDemoUser) {
                localStorage.removeItem("customTheme")
                localStorage.removeItem("customLogo")
                ctx.commit("reduxi/setSiteLogo", null, { root: true })
                const currentTheme = document.body.getAttribute("data-theme") || "default"
                const { setTheme } = require("@/utils/set-theme")
                setTheme(document.documentElement, currentTheme, null, false)
            }

            return Vue.auth.logout()
        },
    },

    getters: {
        user() {
            return Vue.auth.user()
        },
        permissions(state) {
            return state.permissions
        },
        permissionsLoaded(state) {
            return state.isLoaded
        },
        impersonating() {
            return Vue.auth.impersonating()
        },
        isLoaded(state) {
            return state.isLoaded
        },
    },
}
